module.exports = __webpack_public_path__ + "static/media/asfc.a5053d6d.png";